import { elevationScale, zIndexScale } from "@maeiz/tokens";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function ElevationPage() {
    return (
        <DocPage
            title="Elevation & Layering"
            description="Shadows and z-index for Workspace overlays."
        >
            <Section title="Shadows">
                <Demo className="bg-neutral-light dark:bg-neutral-ink">
                    <div className="grid gap-4 sm:grid-cols-2">
                        {(Object.keys(elevationScale) as Array<keyof typeof elevationScale>).map(
                            (k) => (
                                <div
                                    key={k}
                                    className="rounded-mz-xl bg-white p-4 dark:bg-neutral-navy"
                                    style={{
                                        boxShadow:
                                            elevationScale[k] === "none"
                                                ? undefined
                                                : elevationScale[k],
                                    }}
                                >
                                    <p className="font-mono text-sm">{k}</p>
                                </div>
                            )
                        )}
                    </div>
                </Demo>
            </Section>
            <Section title="Z-index">
                <SpecTable rows={Object.entries(zIndexScale).map(([k, v]) => [k, String(v)])} />
            </Section>
        </DocPage>
    );
}
